<template>
  <div @click="editBirthDay()">
    <small class="label">
      {{ $l.userBirthDay }}
    </small>

    <input
      type="text"
      class="input-text with-label"
      v-model="birthDay"
      disabled
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    birthDay: {
      get: function () {
        return this.$store.getters['user/birthDay']
      },

      set: function (birthDay) {
        this.$store.commit('user/setBirthDay', birthDay)
      }
    }
  },

  methods: {
    editBirthDay: function () {
      this.$store.dispatch('popup/show', 'birth-day')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
